<template>
      <div>  
        <form @submit="ctcFormSubmit">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-4">
                            <h3>Fixed Benefits</h3>
                            <div class="mt-4 mb-4">
                                <label class="mr-4">
                                    <input type="radio" name="salaryType" v-model="salaryAsBreakDownOrGrossValue" value="1" class="mt-2" @change="toggleSalaryAsBreakDownOrGross(1)">
                                    <span class="ml-2">Salary as Breakdown</span>
                                </label>
                                <label>
                                    <input type="radio" name="salaryType" v-model="salaryAsBreakDownOrGrossValue" value="0" class="mt-2" @change="toggleSalaryAsBreakDownOrGross(0)">
                                    <span class="ml-2">Gross Salary</span>
                                </label>
                            </div>
                        </div>  
                    </div>
                    
                    <h5 v-if="salaryAsBreakDownOrGrossValue == 1" >Gross Salary Components</h5>
                    <table v-if="salaryAsBreakDownOrGrossValue == 1" class = "table table-bordered table-striped table-hover">                  
                        <thead>
                            <tr class="text-center">
                                <th>Salary Heads as per Settings</th>
                                <th >Show in Annual Letter</th>
                                <th >Show in Compensation Letter</th>
                                <!-- <th>Club with Gross Salary</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="breakDownFixedBenefit in breakDownFixedBenefits" :key="breakDownFixedBenefit.id">
                                <td>
                                    {{ breakDownFixedBenefit.field_title }}
                                </td>
                                <td class="text-center">
                                    <toggle-button :sync="true" :value="!!breakDownFixedBenefit.appear_in_annual" @change="onToggleChange(breakDownFixedBenefit, $event, 'appear_in_annual')"/> 
                                </td>
                                <td class="text-center">
                                    <toggle-button :sync="true" :value="!!breakDownFixedBenefit.appear_in_compensation" @change="onToggleChange(breakDownFixedBenefit, $event, 'appear_in_compensation')"/> 
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="row">
                        <div class="col-lg-4">
                            <h5>Other Monthly Benefits</h5>
                        </div>
                        <div class="col-lg-5"></div>
                        <div class="col-lg-3 text-right">
                            <toggle-button :sync="true" :value="!!parentComponentSettingButtons.fixedBenefits" @change="onToggleChange(breakDownFixedBenefits, $event, 'all', 'fixedBenefits')"/>
                        </div>
                    </div>
                    <table v-if="parentComponentSettingButtons.fixedBenefits" class = "table table-bordered table-striped table-hover">
                        <thead>
                            <tr class="text-center">
                                <th>Salary Heads as per Settings</th>
                                <th>Show in Annual Letter</th>
                                <th>Show in Compensation Letter</th>
                                <th>Ignore Amount  <b-icon class="" icon="info-circle" title='If selected "As per Company Policy" text will appear in the letter.' v-b-tooltip></b-icon>
                                    <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                </th>
                                <th>Same As Gross Salary <b-icon class="" icon="info-circle" title='If selected Gross Salary will appear in the letter.' v-b-tooltip></b-icon>
                                    <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                </th>
                            </tr>
                        </thead>
                        
                        <tbody>
                            <tr v-for="grossFixedBenefit in grossFixedBenefits" :key="grossFixedBenefit.id">
                                <td>
                                    {{ grossFixedBenefit.field_title }}
                                </td>
                                <td class="text-center">
                                    <toggle-button :sync="true" :value="!!grossFixedBenefit.appear_in_annual" @change="onToggleChange(grossFixedBenefit, $event, 'appear_in_annual', 'fixed')"/> 
                                </td>
                                <td class="text-center">
                                    <toggle-button :sync="true" :value="!!grossFixedBenefit.appear_in_compensation" @change="onToggleChange(grossFixedBenefit, $event, 'appear_in_compensation', 'fixed')"/> 
                                </td>
                                <td class="text-center">
                                    <toggle-button :sync="true" :value="!!grossFixedBenefit.ignore_amount" @change="onToggleChange(grossFixedBenefit, $event, 'ignore_amount', 'fixed')"/> 
                                </td>
                                <td class="text-center">
                                    <toggle-button :disabled="grossFixedBenefit.ignore_amount === 1" :sync="true" :value="!!grossFixedBenefit.club_with_gross" @change="onToggleChange(grossFixedBenefit, $event, 'club_with_gross', 'fixed')"/> 
                                </td>
                            </tr>
                        </tbody>
                    </table>
                   
                    <!-- Variable Benefits -->
                    <div class="mt-5">
                        <div class="row">
                            <div class="col-lg-4">
                                <h3 >Variable Benefits</h3>
                            </div>
                            <div class="col-lg-5"></div>
                            <div class="col-lg-3 text-right">
                                <toggle-button :sync="true" :value="!!parentComponentSettingButtons.variableBenefits" @change="onToggleChange(variableBenefits, $event, 'all', 'variableBenefits')"/> 
                            </div>
                        </div>
                        
                        <table v-if="parentComponentSettingButtons.variableBenefits" class = "table table-bordered table-striped table-hover">
                            <thead>
                                <tr class="text-center">
                                    <th>Salary Heads as per Settings</th>
                                    <th >Show in Annual Letter</th>
                                    <th >Show in Compensation Letter</th>
                                    <th>Ignore Amount <b-icon class="" icon="info-circle" title='If selected "As per Company Policy" text will appear in the letter.' v-b-tooltip></b-icon>
                                    <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                    </th>
                                    <th>Same As Gross Salary <b-icon class="" icon="info-circle" title='If selected Gross Salary will appear in the letter.' v-b-tooltip></b-icon>
                                        <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                    </th>
                                </tr>
                            </thead>
                            
                            <tbody>
                                <tr v-for="variableBenefit in variableBenefits" :key="variableBenefit.id">
                                    <td>
                                        {{ variableBenefit.field_title }}
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!variableBenefit.appear_in_annual" @change="onToggleChange(variableBenefit, $event, 'appear_in_annual')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!variableBenefit.appear_in_compensation" @change="onToggleChange(variableBenefit, $event, 'appear_in_compensation')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!variableBenefit.ignore_amount" @change="onToggleChange(variableBenefit, $event, 'ignore_amount')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :disabled="variableBenefit.ignore_amount === 1" :sync="true" :value="!!variableBenefit.club_with_gross" @change="onToggleChange(variableBenefit, $event, 'club_with_gross')"/> 
                                    </td>             
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Contracted Variable Benefits -->
                    <div class="mt-5">
                        <div class="row">
                            <div class="col-lg-4">
                                <h3 >Contracted Variable Benefits</h3>
                            </div>
                            <div class="col-lg-5"></div>
                            <div class="col-lg-3 text-right">
                                <toggle-button :sync="true" :value="!!parentComponentSettingButtons.contractedVariableBenefits" @change="onToggleChange(contractedVariableBenefits, $event, 'all', 'contractedVariableBenefits')"/>
                            </div>
                        </div>
                        <table v-if="parentComponentSettingButtons.contractedVariableBenefits" class = "table table-bordered table-striped table-hover">
                            <thead>
                                <tr class="text-center">
                                    <th>Salary Heads as per Settings</th>
                                    <th >Show in Annual Letter</th>
                                    <th >Show in Compensation Letter</th>
                                    <th>Ignore Amount <b-icon class="" icon="info-circle" title='If selected "As per Company Policy" text will appear in the letter.' v-b-tooltip></b-icon>
                                        <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                    </th>
                                    <th>Same As Gross Salary <b-icon class="" icon="info-circle" title='If selected Gross Salary will appear in the letter.' v-b-tooltip></b-icon>
                                        <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="contractedVariableBenefit in contractedVariableBenefits" :key="contractedVariableBenefit.id">
                                    <td>
                                        {{ contractedVariableBenefit.field_title }}
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!contractedVariableBenefit.appear_in_annual" @change="onToggleChange(contractedVariableBenefit, $event, 'appear_in_annual')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!contractedVariableBenefit.appear_in_compensation" @change="onToggleChange(contractedVariableBenefit, $event, 'appear_in_compensation')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!contractedVariableBenefit.ignore_amount" @change="onToggleChange(contractedVariableBenefit, $event, 'ignore_amount')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :disabled="contractedVariableBenefit.ignore_amount === 1" :sync="true" :value="!!contractedVariableBenefit.club_with_gross" @change="onToggleChange(contractedVariableBenefit, $event, 'club_with_gross')"/> 
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Deductions -->
                    <div class="mt-5">  
                        <div class="row">
                            <div class="col-lg-4">
                                <h3>Deductions</h3>
                            </div>
                            <div class="col-lg-5"></div>
                            <div class="col-lg-3 text-right">
                                <toggle-button :sync="true" :value="!!parentComponentSettingButtons.fixedAndVariableDeductions" @change="onToggleChange(fixedDeductions, $event, 'all', 'fixedAndVariableDeductions')"/> 
                            </div>
                        </div>
                        <table v-if="parentComponentSettingButtons.fixedAndVariableDeductions" class = "table table-bordered table-striped table-hover">
                            <thead>
                                <tr class="text-center">
                                    <th>Salary Heads as per Settings</th>
                                    <th >Show in Annual Letter</th>
                                    <th >Show in Compensation Letter</th>
                                     <th>Ignore Amount <b-icon class="" icon="info-circle" title='If selected "As per Company Policy" text will appear in the letter.' v-b-tooltip></b-icon>
                                        <br> <span><i>(Applicable for Compensation Letter)</i></span>
                                     </th>
                                </tr>
                            </thead>
                            <!-- Fixed Deductions -->
                            <tbody>
                                <tr v-for="fixedDeduction in fixedDeductions" :key="fixedDeduction.id">
                                    <td>
                                        {{ fixedDeduction.field_title }}
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!fixedDeduction.appear_in_annual" @change="onToggleChange(fixedDeduction, $event, 'appear_in_annual')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!fixedDeduction.appear_in_compensation" @change="onToggleChange(fixedDeduction, $event, 'appear_in_compensation')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!fixedDeduction.ignore_amount" @change="onToggleChange(fixedDeduction, $event, 'ignore_amount')"/> 
                                    </td>
                                </tr>

                                <!-- Variable Deductions -->
                                <tr v-for="variableDeduction in variableDeductions" :key="variableDeduction.id">
                                    <td>
                                        {{ variableDeduction.field_title }}
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!variableDeduction.appear_in_annual" @change="onToggleChange(variableDeduction, $event, 'appear_in_annual')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!variableDeduction.appear_in_compensation" @change="onToggleChange(variableDeduction, $event, 'appear_in_compensation')"/> 
                                    </td>
                                    <td class="text-center">
                                        <toggle-button :sync="true" :value="!!variableDeduction.ignore_amount" @change="onToggleChange(variableDeduction, $event, 'ignore_amount')"/> 
                                    </td>
                                </tr>
                            </tbody>    
                        </table>
                    </div>
                </div>
            </div>

            <div class="row justify-content-center mt-3 mb-3">
                <div class="col-lg-2 col-4">
                    <button class="btn btn-success btn-full-width">
                        Submit
                    </button>
                </div>
            </div>
        </form>
        
    </div>
</template>

<script>
export default {
    props: ['pageurl'],
    data () {
        return {
            companyId: '',
            companyAllData: [],
            fixedBenefits: [],
            breakDownFixedBenefits: [],
            grossFixedBenefits: [],
            variableBenefits: [],
            fixedDeductions: [],
            variableDeductions: [],
            contractedVariableBenefits: [],
            salaryAsBreakDownOrGrossValue: 1,
            allCtcSettings: [],

            parentComponentSettingButtons: {
                fixedBenefits: 1,
                variableBenefits: 1,
                contractedVariableBenefits: 1,
                fixedAndVariableDeductions: 0  // 27-01-2025
            },
        }
    },

    created: async function () {
        try {
            await this.getCompany();
            await this.companyAllSettings();
            await this.getCtcSettings();
            await this.getSiteOptionSettings();
            await this.mergeCtcAndCompanySettings();  // 27-01-2025
            this.ctcFormSubmit();
        } catch (error) {
            console.error("Error during initialization:", error);
        }
    },

    methods: {
        async getCompany () {
            try {
                const response = await axios.get(this.pageurl + '/company/getcompany');
                this.companyId = response.data;
            } catch (error) {
                console.error('Error fetching company:', error);
            }
        },
        async companyAllSettings () {
            try {
                const response = await axios.get(this.pageurl + '/companyallsettings/' + this.companyId);
                const data = response.data.data;
                this.companyAllData = response.data.data;
                this.sctionOnlyAndStatusFilter(data.fixed, 'fixedBenefits');
                this.sctionOnlyAndStatusFilter(data.variable, 'variableBenefits');
                this.sctionOnlyAndStatusFilter(data.fixed_deduction, 'fixedDeductions');
                this.sctionOnlyAndStatusFilter(data.variable_deduction, 'variableDeductions');
                this.sctionOnlyAndStatusFilter(data.contracted_variable_benefits, 'contractedVariableBenefits');
                this.basicAndGrossDistribution(this.fixedBenefits);
            } catch (error) {
                console.error('Error fetching company settings:', error);
            }
        },
        async getCtcSettings() {
            try {
                const response = await axios.get(this.pageurl + '/get-ctc-settings');
                this.allCtcSettings = response.data.ctcSettings;
            } catch (error) {
                console.error('Error fetching CTC settings:', error);
            }
        },
        async getSiteOptionSettings() {
            try {
                const response = await axios.get(this.pageurl + '/get-ctc-site-options');
                response.data.forEach(option => {
                    if(option.opt_key === "ctc_fixed_benefits") {
                        this.parentComponentSettingButtons.fixedBenefits = option.status;   
                    } else if (option.opt_key === "ctc_variable_benefits") {
                        this.parentComponentSettingButtons.variableBenefits = option.status;
                    } else if (option.opt_key === "ctc_contracted_variable_benefits") {
                        this.parentComponentSettingButtons.contractedVariableBenefits = option.status;
                    } else if (option.opt_key === "ctc_deductions") {
                        this.parentComponentSettingButtons.fixedAndVariableDeductions = option.status;
                    } else if (option.opt_key === "ctc_salary_as_break_down_or_gross") {
                        this.salaryAsBreakDownOrGrossValue = option.status;
                    }
                })
            } catch (error) {
                console.error('Error fetching Site Option Setting: ', error);
            }
        },
        async mergeCtcAndCompanySettings() {  // 27-01-2025
            const settingsMap = Object.fromEntries(
                this.allCtcSettings.map(setting => [String(setting.settings_id), setting])
            );

            const updateBenefits = (settingsName, benefitsArray) => {
                return benefitsArray.map(benefit => ({
                    ...benefit,
                    appear_in_compensation: benefit.appear_in_compensation || '',
                    appear_in_annual: benefit.appear_in_annual || '',
                    club_with_gross: benefit.club_with_gross || '',
                    ignore_amount: benefit.ignore_amount || ''
                })).map(benefit => {
                    const matchingSetting = settingsMap[String(benefit.id)];
                    // Modify the benefit values based on the settingsName
                    if (settingsName === 'breakDownFixedBenefits' || settingsName === 'grossFixedBenefits') {
                        benefit.appear_in_annual = 1;
                        benefit.appear_in_compensation = 1;
                        benefit.ignore_amount = 0;
                        // benefit.club_with_gross = 1;
                        benefit.club_with_gross = 0; // 27-01-2025
                    } else if (settingsName === 'variableBenefits' || settingsName === 'contractedVariableBenefits') {
                        benefit.appear_in_annual = 1;
                        benefit.appear_in_compensation = 1;
                        benefit.club_with_gross = 0;
                        // benefit.ignore_amount = 1;
                        benefit.ignore_amount = 0;  // 27-01-2025
                    } else if (settingsName === 'fixedDeductions' || settingsName === 'variableDeductions') {
                            benefit.appear_in_annual = 0;
                            benefit.appear_in_compensation = 0;
                            benefit.club_with_gross = 0;
                            benefit.ignore_amount = 0;
                    }
                    return {
                        ...benefit,
                        appear_in_compensation: matchingSetting ? matchingSetting.appear_in_compensation : benefit.appear_in_compensation,
                        appear_in_annual: matchingSetting ? matchingSetting.appear_in_annual : benefit.appear_in_annual,
                        club_with_gross: matchingSetting ? matchingSetting.club_with_gross : benefit.club_with_gross,
                        ignore_amount: matchingSetting ? matchingSetting.ignore_amount : benefit.ignore_amount,
                    };
                });
            };

            // Apply to all specified arrays
            this.breakDownFixedBenefits = updateBenefits('breakDownFixedBenefits', this.breakDownFixedBenefits);
            this.grossFixedBenefits = updateBenefits('grossFixedBenefits', this.grossFixedBenefits);
            this.variableBenefits = updateBenefits('variableBenefits', this.variableBenefits);
            this.fixedDeductions = updateBenefits('fixedDeductions', this.fixedDeductions);
            this.variableDeductions = updateBenefits('variableDeductions', this.variableDeductions);
            this.contractedVariableBenefits = updateBenefits('contractedVariableBenefits', this.contractedVariableBenefits);
        },
        sctionOnlyAndStatusFilter: function(values, settingName) {
            const targetArray = this[settingName]; 
            Object.values(values).forEach(element => {
                if (element.section_only === 1) {
                    if (element.child_components) {
                        Object.values(element.child_components).forEach(child => {
                            if (child.status === 1) {
                                child.field_type = element.field_type;
                                targetArray.push(child);
                            }
                        });
                    }
                } else if(element.status === 1) {
                    targetArray.push(element);
                }
            });
        },
        basicAndGrossDistribution: function(fixedBenefits) {
            Object.keys(fixedBenefits).forEach(key => {
                    const element = fixedBenefits[key];

                    if (element.field_access_key && element.field_access_key.indexOf('custom_gross_salary') >= 0) {
                        if(element.field_access_key.startsWith('custom_gross_salary')) {
                            this.breakDownFixedBenefits.push(element);
                        }
                    } else if(element.field_access_key === 'basic_salary' || element.field_access_key === 'house_rent' || element.field_access_key === 'medical_allowance' || element.field_access_key === 'conveyance_allowance') {
                            this.breakDownFixedBenefits.push(element);
                    } 

                    if((element.field_access_key && element.field_access_key.indexOf('custom_gross_salary') >= 0) || (element.field_access_key === 'basic_salary' || element.field_access_key === 'house_rent' || element.field_access_key === 'medical_allowance' || element.field_access_key === 'conveyance_allowance')) {
                        
                    } else {
                        this.grossFixedBenefits.push(element);
                    }
            });
        },
        onToggleChange: function (element, event, column, settingName = null) {
            let value = event.value === true ? 1 : 0;
        
            if (column === 'all' && settingName) {
                if (this.parentComponentSettingButtons.hasOwnProperty(settingName)) {
                    this.parentComponentSettingButtons[settingName] = value;
                }
                
                if(settingName === 'fixedBenefits') {
                    this.parentComponentSettingButtons.fixedBenefits = value;
                } else if (settingName === 'variableBenefits') {
                    this.parentComponentSettingButtons.variableBenefits = value;
                } else if (settingName === 'contractedVariableBenefits') {
                    this.parentComponentSettingButtons.contractedVariableBenefits = value;
                } else if (settingName === 'fixedAndVariableDeductions') {
                    this.parentComponentSettingButtons.fixedAndVariableDeductions = value;
                } 
                
                // Mapping between settingName and the corresponding benefits array
                const settingsMap = {
                    fixedBenefits: [this.grossFixedBenefits],
                    variableBenefits: [this.variableBenefits],
                    contractedVariableBenefits: [this.contractedVariableBenefits],
                    fixedAndVariableDeductions: [this.fixedDeductions, this.variableDeductions]
                };

                if(value === 0 ) {
                    const targetArrays = settingsMap[settingName];
                    if (targetArrays) {
                        targetArrays.forEach(benefitsArray => {
                            benefitsArray.forEach(benefit => {
                                benefit.appear_in_annual = value;
                                benefit.appear_in_compensation = value;
                                benefit.club_with_gross = value;
                                if (settingName !== 'fixedBenefits') {
                                    benefit.ignore_amount = value;
                                }
                            });
                        });
                    }
                }
            } else if (column) {
                if (column == 'ignore_amount' && value == 1) {
                    element['club_with_gross'] = 0;
                }
                element[column] = value;
            }
        },
        ctcFormSubmit: function(e) {
            // 27-01-2025
            if (e) {
                e.preventDefault(); // Prevent default only if an event is passed
            }
            // 27-01-2025
            // e.preventDefault();
            let formData = new FormData();
            const arraysToInclude = {
                breakDownFixedBenefits: this.breakDownFixedBenefits,
                grossFixedBenefits: this.grossFixedBenefits,
                variableBenefits: this.variableBenefits,
                fixedDeductions: this.fixedDeductions,
                variableDeductions: this.variableDeductions,
                contractedVariableBenefits: this.contractedVariableBenefits,
                settingButtonAndEvent: this.parentComponentSettingButtons,
            };
            
            // Serialize and add each array to FormData
            Object.keys(arraysToInclude).forEach((key) => {
                formData.append(key, JSON.stringify(arraysToInclude[key]));
            });
            formData.append('salaryAsBreakDownOrGross', this.salaryAsBreakDownOrGrossValue);
            formData.append('companyId', this.companyId);

            axios.post(this.pageurl + '/ctc-settings', formData)
                .then(response => {
                    if(e) {
                        if (response.data.success === true) {
                            this.$bvToast.toast("Settings Updated!!!", {title: 'Success',variant: 'success',solid: true, toaster: "toaster: b-toaster-top-right"});
                        } else {
                            this.$bvToast.toast("Invalid Company", {title: 'Error',variant: 'danger',solid: true, toaster: "toaster: b-toaster-top-right"});
                        }
                    }
                    
                })
                .catch(error => {
                    console.error('Error submitting form:', error);
                });
            
        },
        toggleSalaryAsBreakDownOrGross: function(value) {
            this.salaryAsBreakDownOrGrossValue = value;
        }
    },
    
}
</script>

<style scoped>
table thead {
    background-color: #04544c;
    color: white;
}
</style>

